<div class="container_dati-generali">
  <form #f="ngForm" [formGroup]="soggettoForm" (ngSubmit)="submit()">
    <div class="row">
      <ng-template [ngIf]="parte.tipoPersona.label == 'FISICA'">
        <div
          labelTextInput
          class="col-sm-3 bloccodati"
          [typeLabel]="'text'"
          [labelInput]="'Cognome/Nome'"
          [valueInput]="parte.cognome+' '+parte.nome"
        ></div>
        <div
          labelTextInput
          class="col-sm-3 bloccodati"
          [typeLabel]="'text'"
          [labelInput]="'Tipo persona'"
          [valueInput]="parte.tipoPersona.label"
        ></div>
        <div
          labelTextInput
          class="col-sm-3 bloccodati"
          [typeLabel]="'text'"
          [labelInput]="'Matricola'"
          [valueInput]="parte.matricola"
        ></div>
        <div
          labelTextInput
          class="col-sm-3 bloccodati"
          [typeLabel]="'text'"
          [labelInput]="'Codice fiscale'"
          [valueInput]="parte.codiceFiscale"
        ></div>
      </ng-template>
      <ng-template [ngIf]="parte.tipoPersona.label == 'GIURIDICA'">
        <div
          labelTextInput
          class="col-sm-4 bloccodati"
          [typeLabel]="'text'"
          [labelInput]="'Ragione sociale'"
          [valueInput]="parte.ragioneSociale"
        ></div>
        <div
          labelTextInput
          class="col-sm-4 bloccodati"
          [typeLabel]="'text'"
          [labelInput]="'Tipo persona'"
          [valueInput]="parte.tipoPersona.label"
        ></div>
        <div
          labelTextInput
          class="col-sm-4 bloccodati"
          [typeLabel]="'text'"
          [labelInput]="'Partita iva'"
          [valueInput]="parte.partitaIva"
        ></div>
      </ng-template>
    </div>
    <div class="row">
      <div
        comboModInput
        [ngClass] ="{'component-suggested': this.suggestedCategory}"
        class="col-sm-6"
        formControlName="categoriaAltraParte"
        [labelInput]="'Categoria'"
        [ngModel]="altraParte?.categoriaAltraParte"
        [mandatory]="true"
        [optionsCombo]="categoriaOptions"
        [control]="soggettoForm.controls['categoriaAltraParte']"
        [labelOption]="'label'"
        [objectReference]="soggettoForm.get('categoriaAltraParte').value"
        (onReturn)="soggettoForm.get('categoriaAltraParte').setValue($event)"
      ></div>

      <div
        comboModInput
        class="col-sm-6"
        formControlName="controparte"
        [labelInput]="'Parte (Se Legale di Controparte)'"
        [optionsCombo]="controparteOptions"
        [control]="soggettoForm.controls['controparte']"
        [labelOption]="'parte.nominativo'"
        [objectReference]="soggettoForm.get('controparte').value"
        (onReturn)="soggettoForm.get('controparte').setValue($event)"
        [submitPending]="soggettoForm.get('controparte').disabled"
      ></div>
    </div>
    <div class="row">
      <div
        checkBoxRadio
        class="col-sm-4"
        formControlName="ritirato"
        [labelInput]="'Rinunciatario'"
        [idInput]="idInput"
        [control]="soggettoForm.controls['ritirato']"
        [objectReference]="soggettoForm.get('ritirato').value"
        (onReturn)="soggettoForm.get('ritirato').setValue($event)"
      ></div>
      <div datePickerInput class="col-sm-4" [labelInput]="'Data rinuncia'"
        [submitPending]="!soggettoForm.get('ritirato').value"
        formControlName="dataTermine" (onReturn)="soggettoForm.get('dataTermine').setValue($event)"
        [mandatory]="soggettoForm.get('ritirato').value">
      </div>
    </div>
    <div class="row"></div>
    <div class="row">
      <p class="mandatory col-sm-12">
        <em>* Campi obbligatori</em>
      </p>
    </div>

    <div class="row" *ngIf="!altraParte; else edit">
      <p class="col-sm-3 col-xs-3 col-xs-offset-9 col-sm-offset-9">
        <button type="submit" class="btn btn-primary btn-block" [disabled]="!soggettoForm.valid">
          Inserisci Soggetto
        </button>
      </p>
    </div>
    <ng-template #edit>
      <div class="row">
        <p class="col-sm-3 col-xs-3 col-xs-offset-9 col-sm-offset-9">
          <button type="button" (click)="editAltraParte()" class="btn btn-primary btn-block" [disabled]="!soggettoForm.valid">
            Completa associazione
          </button>
        </p>
      </div>
    </ng-template>
  </form>
</div>
